export default [
'10001+',
'5001-10000',
'1001-5000',
'501-1000',
'101-500',
'51-100',
'11-50',
'0-10'
];